class CanvasDownload {

    constructor(img = '.download-img', link = '.js-download' ) {
        this.img = img;
        this.link = link;
    }

    createCanvas() {
        const canvas  = document.createElement('canvas');

        canvas.setAttribute('id', 'canvas-download');
        canvas.style.display = 'none';
        document.querySelector('body').appendChild(canvas);
    }

    createWaterMark() {
        const watermark  = document.createElement('img');

        watermark.setAttribute('crossOrigin', 'Anonymous');
        watermark.setAttribute('id', 'watermark');
        watermark.setAttribute('src', '//cdn.sandals.com/sandals/v12/images/media-gallery/watermark.png');
        watermark.style.display = 'none';
        document.querySelector('body').appendChild(watermark);
    }

    convertImageToCanvas() {
        const watermark = document.querySelector('#watermark');
        const canvas = document.querySelector('#canvas-download');
        const cntxt = canvas.getContext('2d');
        const img = document.querySelector(this.img);


        img.setAttribute('crossOrigin', 'Anonymous');

        canvas.height = img.naturalHeight;
        canvas.width = img.naturalWidth;

        cntxt.drawImage(img, 0, 0);
        if (watermark !== null) {
            cntxt.drawImage(watermark, (img.naturalWidth - watermark.naturalWidth), (img.naturalHeight - watermark.naturalHeight));
        }
        const link = document.querySelector(this.link);

        link.href = canvas.toDataURL('image/jpeg');
    }
}

export default CanvasDownload;
